import { render, staticRenderFns } from "./EmailEventsGroupFilter.vue?vue&type=template&id=023d3200&"
import script from "./EmailEventsGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./EmailEventsGroupFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports